import { useLocation, useNavigate } from "react-router-dom";
import LunchCreator from "../../common/lunchCreator/LunchCreator";
import { saveTemplate } from "../../../utils/api/templates";

const CreateTemplatePage = () => {
    const {state} = useLocation();
    const navigate = useNavigate();
    const {template, id} = state || {};
    const handleSaveTemplateSuccess = () => {
        navigate('/templates');
    }

    const handleSubmit = async (lunch) => {
        await saveTemplate(id, lunch, handleSaveTemplateSuccess);
    };

    return (
        <LunchCreator
            onSubmit={handleSubmit}
            submitLabel="Save"
            template={template}
        />
    );
}

export default CreateTemplatePage;
